import { useMutation } from '@tanstack/react-query'
import { confirmPayment } from '../../service/payment'

function useConfirmPayment() {
  return useMutation({
    mutationKey: ['confirm-payment'],
    mutationFn: confirmPayment,
  })
}

export default useConfirmPayment
